<template>
  <div class="cardContent" :id="cardId">
    <img class="imgCard" alt="team-icon" :src="require('../assets/cards/' + table.card_type + '/' + mappedCardId + '.png')" width="100" height="180"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Card",
  props: {
    cardId: {
      type: String,
      required: true
    },
  },
  computed: {
    ...mapGetters({
      table: "tables/tableActive"
    }),
    mappedCardId(){
      const mapp = {Ad: 'acediamonds'};
      return mapp[this.cardId] ? mapp[this.cardId] : this.cardId;
    },
  }
}
</script>
<style scoped>
.cardContent {
  margin: 0.5em;
}
img {
  border-radius: 6%;
}
@media all and (min-width: 960px) {
  .cardContent {
      margin: 0.3em;
  }
}

@media all and (min-width: 760px) and (max-width: 960px) {
  img {
    width: 80px;
    height: 150px;
  }
}
@media all and (min-width: 685px) and (max-width: 760px) {
  img {
    width: 70px;
    height: 130px;
  }
}
@media all and (min-width: 570px) and (max-width: 685px) {
  img {
    width: 60px;
    height: 113px;
  }
}
@media all and (max-width: 570px) {
  img {
    width: 50px;
    height: 100px;
  }
}

@media all and (max-height: 600px) {
  img {
    width: 45px;
    height: 85px;
  }
}

</style>
